"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_link_1 = require("apollo-link");
var apollo_utils_1 = require("./apollo-utils");
var ApiClient = /** @class */ (function () {
    function ApiClient(_a) {
        var link = _a.link, queries = _a.queries, mutations = _a.mutations, subscriptions = _a.subscriptions, modifyVariables = _a.modifyVariables;
        this.link = link;
        this.operationsMap = new Map(Object.entries(__assign(__assign(__assign({}, (queries || {})), (mutations || {})), (subscriptions || {}))));
        this.modifyVariables = modifyVariables;
    }
    ApiClient.prototype.subscribe = function (requestOptions) {
        var _this = this;
        var sub;
        var observers = [];
        return new apollo_link_1.Observable(function (observer) {
            observers.push(observer);
            // If this is the first observer, actually initiate the network
            // subscription.
            if (observers.length === 1) {
                var activeNextCalls_1 = 0;
                var complete_1 = false;
                var handler_1 = {
                    next: function (result) {
                        activeNextCalls_1 += 1;
                        observers.forEach(function (obs) {
                            // If an error exists and a `error` handler has been defined on
                            // the observer, call that `error` handler and make sure the
                            // `next` handler is skipped. If no `error` handler exists, we're
                            // still passing any errors that might occur into the `next`
                            // handler, to give that handler a chance to deal with the
                            // error (we're doing this for backwards compatibilty).
                            if (apollo_utils_1.graphQLResultHasError(result) && obs.error) {
                                obs.error(new apollo_utils_1.ApolloError({
                                    graphQLErrors: result.errors,
                                }));
                            }
                            else if (obs.next) {
                                obs.next(result);
                            }
                            activeNextCalls_1 -= 1;
                        });
                        if (activeNextCalls_1 === 0 && complete_1) {
                            handler_1.complete();
                        }
                    },
                    error: function (error) {
                        observers.forEach(function (obs) {
                            if (obs.error) {
                                obs.error(error);
                            }
                        });
                    },
                    complete: function () {
                        if (activeNextCalls_1 === 0) {
                            observers.forEach(function (obs) {
                                if (obs.complete) {
                                    obs.complete();
                                }
                            });
                        }
                        complete_1 = true;
                    },
                };
                var method = requestOptions.method, variables = requestOptions.variables;
                var operation = _this.createApolloRequest({
                    method: method,
                    variables: variables,
                });
                sub = apollo_link_1.execute(_this.link, operation).subscribe(handler_1);
            }
            return function () {
                observers = observers.filter(function (obs) { return obs !== observer; });
                // If we removed the last observer, tear down the network subscription
                if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                }
            };
        });
    };
    ApiClient.prototype.makeRequest = function (requestOptions) {
        return this.callApi(this.createApolloRequest(requestOptions));
    };
    ApiClient.prototype.callApi = function (request, context) {
        return apollo_link_1.makePromise(apollo_link_1.execute(this.link, {
            query: request.query,
            variables: request.variables,
            context: context,
        }));
    };
    ApiClient.prototype.createApolloRequest = function (_a) {
        var method = _a.method, variables = _a.variables;
        var query = this.operationsMap.get(method);
        if (!query) {
            throw new Error("No GQL query registered for method: " + method);
        }
        if (this.modifyVariables) {
            var modifiedVariables = this.modifyVariables(method, variables);
            return { query: query, variables: modifiedVariables };
        }
        return { query: query, variables: variables };
    };
    return ApiClient;
}());
exports.default = ApiClient;
//# sourceMappingURL=client.js.map